import moment from 'moment';

export default function EventDate({ date }) {
  return (
    <div className="font-semibold text-gray-500">
      {moment(date).format('MMMM e, YYYY')}
    </div>
  );
}
